/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_IntroInputs */

const en_csv_to_json_intro = /** @type {(inputs: Csv_To_Json_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn a spreadsheet export into an array of objects. The header row supplies the keys, and quoted fields containing commas or line breaks are parsed correctly.`)
};

const ko_csv_to_json_intro = /** @type {(inputs: Csv_To_Json_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스프레드시트 내보내기를 객체 배열로 바꿉니다. 헤더 행이 키를 제공하며, 쉼표나 줄바꿈을 담은 인용 필드도 올바르게 파싱됩니다.`)
};

const ja_csv_to_json_intro = /** @type {(inputs: Csv_To_Json_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表計算のエクスポートをオブジェクトの配列に変えます。ヘッダ行がキーを与え、カンマや改行を含む引用フィールドも正しくパースされます。`)
};

/**
* | output |
* | --- |
* | "Turn a spreadsheet export into an array of objects. The header row supplies the keys, and quoted fields containing commas or line breaks are parsed correctly." |
*
* @param {Csv_To_Json_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_intro = /** @type {((inputs?: Csv_To_Json_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_intro(inputs)
	if (locale === "ko") return ko_csv_to_json_intro(inputs)
	return ja_csv_to_json_intro(inputs)
});